<template>

  <v-container
      class="fill-height"
      fluid
  >
    <v-row
        align="center"
        justify="center"
    >
      <v-col
          cols="12"
          sm="8"
          md="4"
      >
        <v-card class="elevation-12">


          <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <v-toolbar
                color="primary"
                dark
                flat
            >
              <v-toolbar-title>{{ $t("Recuperar Contraseña")}}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <v-alert type="success" v-if="success">
                  {{ $t('Te hemos enviado un email para recuperar la contraseña') }}
                </v-alert>

              <v-form v-if="!success">

<v-alert
                    v-if="haserror"
                    color="black"
                    dark
                    border="top"
                    icon="mdi-alert-circle"
                    transition="scale-transition"
                >
                  {{ $t("No reconocemos este email") }}
                </v-alert>


                <ValidationProvider v-slot="{ errors }" rules="required|email">

                  <v-text-field
                      :label="$t('Email')"
                      name="login"
                      prepend-icon="mdi-account"
                      type="text"
                      v-model="email"
                      :error-messages="errors"

                  ></v-text-field>
                </ValidationProvider>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="getpassword()" color="primary">{{ $t("Enviar")}}</v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

    import axios from "axios";
    import {ValidationObserver, ValidationProvider} from "vee-validate";

    export default {
        name: "login",
        props: {
            source: String,
        },
        components: {
            ValidationProvider, ValidationObserver
        },
        data() {
            return {
                email: "",
                hassuccess: false,
                haserror:false
            }
        },
        methods: {
            getpassword() {
                this.$refs.observer.validate().then(success => {
                    if (success) {
                        let u = this.email
                        const payload = {
                            "email": u,
                        }
                        axios.post(this.$store.state.endpoints.newpassword, payload)
                            .then(() => {
                                this.email = ""
                                this.success = true
                            })
                            .catch(() => {
                                this.haserror = true
                            })
                    }
                })
            }
        }
    }
</script>
